<template>
  <v-container fluid>
    <v-dialog v-model="addSectionDialog" width="700">
      <v-card>
        <v-container>
          <v-layout row wrap justify-center align-center>
            <v-flex xs12>
              <v-text-field name="title" label="Section Name" hint="Section name is required" value="Input text" v-model="newSectionName"
                            class="v-input--is-focused blue--text" required></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select required v-bind:items="subCategories"  label="Sub Cateory" item-text="text" item-value="id" v-model="newSectionCategory"></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select required v-bind:items="sectionsListForNewSection"  label="Insert Before Section" item-text="text" item-value="id" v-model="newSectionBefore"></v-select>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <v-btn :disabled="!sectionReadyToAdd" color="primary" small @click="newSection">Confirm</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
      <v-dialog v-model="addSubCatDialog" width="700">
        <v-card>
          <v-container>
            <v-layout row wrap justify-center align-center>
              <v-flex xs12>
                <v-text-field name="title" label="Sub Category Name" hint="Sub Category name is required" value="Input text" v-model="newSubCatName"
                              class="v-input--is-focused blue--text" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select required v-bind:items="subCategories"  label="Insert Before Chapter" item-text="text" item-value="id" v-model="newSubCatBefore"></v-select>
              </v-flex>
              <v-flex xs12 text-xs-center>
                <v-btn :disabled="!subCatReadyToAdd" color="primary" small @click="newSubCat">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    <v-flex xs12>
      <v-card class="grey lighten-4 elevation-0">
        <v-card-title style="background: #e3f2fd; text-transform: capitalize;" class="title">
          {{title}}          &nbsp;
          <v-spacer></v-spacer>
          <v-btn :disabled="!unsavedChanges" fab small class="green darken-2" @click.native="saveLawGuide()">
            <v-icon color="white">save</v-icon>
          </v-btn>
          <v-btn fab small class="grey" @click.native="cancel()">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-container fluid grid-list-md >
            <v-layout row wrap>
           <v-flex xs12>
             <v-layout row wrap>
               <v-flex xs8>
                 <v-select v-on:change="chapterChanged" required v-bind:items="chapters" label="Chapter" item-text="text" item-value="id" v-model="selectedChapter"></v-select>
               </v-flex>
               <v-flex xs4 v-if="selectedChapter != null">
                 <v-layout row wrap>
                   <v-flex xs12 text-xs-center>
                     <v-btn  color="primary" small @click="addSubCatDialog = true">Add Sub Category</v-btn>
                     <v-btn  color="primary" small @click="addSectionDialog = true">Create Section</v-btn>
                   </v-flex>
                   <v-flex text-xs-center v-if="unsavedChanges">
                     <small style="color: red">You have unsaved changes</small>
                   </v-flex>
                 </v-layout>
               </v-flex>
             </v-layout>

             <br/>
             <v-divider></v-divider>
             <br/>
            </v-flex>
            <v-flex xs12 v-if="filteredItems.length > 0">
              <DragDropLawGuide :bus="bus" v-on:changed="datasetChange" :dataset="filteredItems" ></DragDropLawGuide>
              </v-flex>
              <v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>


</template>
<script>
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import DragDropLawGuide from "@/components/DragDropLawGuide";
import Vue from "vue";
export default {
  name: 'LawGuidEdit',
  data () {
    return {
      bus: new Vue(),
      newDataSet: null,
      originalDataSet: null,
      addSectionDialog: false,
      newSectionName: null,
      newSectionCategory: null,
      newSectionBefore: null,
      newSubCatName: null,
      newSubCatBefore: null,
      addSubCatDialog: false,
      filteredItems: [],
      selectedChapter: null,
      catCounter:0,
      searchValue: '',
      dialog: false,
      title: 'School Law Guide Editor'
    }
  },
  mounted() {
    this.$fetchData()
  },
  computed: {
    unsavedChanges(){
      //console.log('in unsaved changes', this.originalDataSet, this.newDataSet )
      return (this.originalDataSet !== '[]' && this.originalDataSet !== JSON.stringify(this.newDataSet))
    },
    subCatReadyToAdd(){
      if(this.newSubCatName != null && this.newSubCatName.length > 6) {
        //if(this.newSubCatBefore != null || this.subCategories.length == 0) {
          return true
      //  }
      }
      return false;
    },
    sectionReadyToAdd(){
      if(this.newSectionName != null && this.newSectionName.length > 6 && this.newSectionCategory != null) {
        return true
      }
      return false;
    },
    sectionsListForNewSection() {
      console.log('looking for sections in cat',this.newSectionCategory)
      return this.filteredItems.filter((x) => x.group == 'section' && x.parent == this.newSectionCategory)
    },
    subCategories(){
      console.log('return ing sub', this.selectedChapter)
      return this.filteredItems.filter((x) => x.group == 'subcat' && x.parent == this.selectedChapter)
    },
    chapters() {
      return [
        {
          id: 'c0',
          class: 'chapter',
          text: 'School Districts',
        },
        {
          id: 'c1',
          class: 'chapter',
          text: 'Students',
        },
        {
          id: 'c2',
          class: 'chapter',
          text: 'Employees and Teachers',
        },
        {
          id: 'c3',
          class: 'chapter',
          text: 'School Districts - Organization Options',
        },
        {
          id: 'c4',
          class: 'chapter',
          text: 'Special Education and Early Childhood Intervention',
        },
        {
          key: 'c6',
          class: 'chapter',
          text: 'Charter Schools',
        },
        {
          id: 'c5',
          class: 'chapter',
          text: 'Minnesota State High School League',
        },

      ]
    }
  },
  methods: {
    saveLawGuide() {
      console.log('in save', this.selectedChapter, this.newDataSet)
      this.$saveLawGuideChapter(this.selectedChapter, this.newDataSet).then((result)=>{
        console.log('save result', result)
        this.updateDragAndDropDataSet()
      })
    },
    datasetChange(newData) {
      this.newDataSet = newData
      console.log('caught event', newData)
    },
    cancel () {
      this.$router.back()
    },
    newSection() {
      this.bus.$emit('newSection', this.newSectionCategory, this.newSectionName)
      this.addSectionDialog = false
      this.newSectionCategory = null
      this.newSectionName = null
      this.newSectionBefore = null
    },
    newSubCat() {
      this.bus.$emit('newSubCat', this.selectedChapter, this.newSubCatName)
      this.addSubCatDialog = false
      this.newSubCatName = null
      this.newSubCatBefore = null
      //this.saveLawGuide()
      //this.updateDragAndDropDataSet();
    },
    chapterChanged(){
      this.updateDragAndDropDataSet();
    },
    updateDragAndDropDataSet() {
      this.filteredItems = []
      console.log(this.$lawguidestructure)
      this.$nextTick(function () {
        let itemsToUse = this.$lawguidestructure.find((x)=>x.id === this.selectedChapter)
console.log('items', itemsToUse)
        if(itemsToUse !== undefined) {

          this.originalDataSet = itemsToUse.jsonData
          itemsToUse = JSON.parse(itemsToUse.jsonData)
        } else {
          itemsToUse = []
        }



        this.filteredItems = itemsToUse;

      })
      this.$forceUpdate();
    }
  },
  components: {
    DragDropLawGuide,
  },
}
</script>